<div class="workunit-container properties" ng-controller="WorkUnitsController as wuCtrl">
    <header>
        <h1>{{'workUnits.header'|translate}}</h1>
        <p class="form-description">{{'workUnit.usage.description'|translate}}</p>
    </header>

    <c-tree-explorer class="display-tree" config="wuCtrl.treeConfig"></c-tree-explorer>
</div>